// extracted by mini-css-extract-plugin
export default {"tag":"OenME8","rounded":"aT6nwl","inner":"gOCw08"};